export default {
  setting: (state) => {
    return state.setting;
  },
  booths: (state) => {
    return state.booths;
  },
  boothOptions: (state) => {
    return (state.booths || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  storeOptions: (state) => {
    return (state.storeOptions || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  branchUserPersons: (state) => {
    return state.branchUserPersons;
  },
  branchUserOptions: (state) => {
    return (state.branchUserPersons || []).map((item) => ({
      value: item.userId,
      text: item.username ? item.title + " (" + item.username + ")" : item.title,
      personId: item.personId,
    }));
  },
  stores: (state) => {
    return state.stores;
  },
  boothList: (state) => {
    return state.boothList;
  },
  preOrders: (state) => {
    return state.preOrders;
  },
  preOrderById: (state) => {
    return state.preOrderById;
  },
};
